module.exports = __webpack_public_path__ + "static/media/icon-unread.ecb0be5e.svg";